import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Home, Palette, Eye } from 'lucide-react';
import { Card, CardContent } from './ui/Card';
export function FeaturesSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 bg-cream" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-17">
            A Better Way to Build
          </h2>
          <p className="text-lg text-charcoal/70" data-id="element-18">
            We've reimagined the homebuilding process to give you complete
            confidence in your choices.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-19">
          {/* Feature 1 */}
          <motion.div variants={itemVariants} data-id="element-20">
            <Card className="h-full border-none shadow-md hover:shadow-lg transition-shadow duration-300 bg-white" data-id="element-21">
              <CardContent className="p-8 flex flex-col items-center text-center h-full" data-id="element-22">
                <div className="w-16 h-16 rounded-full bg-forest/5 flex items-center justify-center mb-6 text-forest" data-id="element-23">
                  <Home size={32} strokeWidth={1.5} data-id="element-24" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-25">Browse Floor Plans</h3>
                <p className="text-charcoal/70 leading-relaxed" data-id="element-26">
                  Explore our collection of thoughtfully designed homes for
                  every lifestyle, crafted for the Pacific Northwest.
                </p>
              </CardContent>
            </Card>
          </motion.div>

          {/* Feature 2 */}
          <motion.div variants={itemVariants} data-id="element-27">
            <Card className="h-full border-none shadow-md hover:shadow-lg transition-shadow duration-300 bg-white relative overflow-hidden" data-id="element-28">
              <div className="absolute top-0 left-0 w-full h-1 bg-gold" data-id="element-29"></div>
              <CardContent className="p-8 flex flex-col items-center text-center h-full" data-id="element-30">
                <div className="w-16 h-16 rounded-full bg-gold/10 flex items-center justify-center mb-6 text-gold" data-id="element-31">
                  <Palette size={32} strokeWidth={1.5} data-id="element-32" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-33">
                  Customize Your Finishes
                </h3>
                <p className="text-charcoal/70 leading-relaxed" data-id="element-34">
                  Choose cabinets, countertops, flooring, and more to make it
                  yours. See your choices come together instantly.
                </p>
              </CardContent>
            </Card>
          </motion.div>

          {/* Feature 3 */}
          <motion.div variants={itemVariants} data-id="element-35">
            <Card className="h-full border-none shadow-md hover:shadow-lg transition-shadow duration-300 bg-white" data-id="element-36">
              <CardContent className="p-8 flex flex-col items-center text-center h-full" data-id="element-37">
                <div className="w-16 h-16 rounded-full bg-forest/5 flex items-center justify-center mb-6 text-forest" data-id="element-38">
                  <Eye size={32} strokeWidth={1.5} data-id="element-39" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-40">Walk Through in 3D</h3>
                <p className="text-charcoal/70 leading-relaxed" data-id="element-41">
                  Step inside your future home and experience every detail
                  before it's built with our immersive virtual technology.
                </p>
              </CardContent>
            </Card>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}